<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <!-- <div>Chọn file upload <span class="text-danger">*</span></div> -->
          <div><a :href="activeFID==1 ? 'static/import_contact_template_fid.xlsx':'static/import_contact_template.xlsx'" target="_blank">{{ $t("downloadSampleFile") }}</a></div>
        </div>
      </template>
      <b-form-file v-model="file" accept=".xlsx" placeholder="" />
      <!-- <b-form-file v-model="listImage" multiple accept="image/*" placeholder="" /> -->
    </b-form-group>

    <b-form-group v-if="activeFID==1">
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>{{ $t("faceImageTitle1") }} <span class="text-danger">({{ $t("faceImageTitle2") }})</span></div>
         </div>
      </template>
      <b-form-file v-model="listImage" multiple accept="image/*" :placeholder="$t('faceChosePlaceholder')" />
    </b-form-group>

    <!-- Ẩn tính năng/ upcode prod -->
    <!-- <b-form-group>
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>{{ $t("APIURLContactImport") }}</div>
         </div>
      </template>      
      <b-form-input id="input-contact-title" type="text" v-model="apiUrl" name="apiUrl" maxlength="500"></b-form-input>
    </b-form-group> -->

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("importFromFile") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as contactService from "@/service/contactService";
  import * as validationUtils from "@/service/validationUtils";

  @Component
  export default class ImportContactsFromExcelFileModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;
    @Prop({ required: true }) activeFID: any;

    file: File = null;
    listImage: any = null;
    apiUrl: string = "";

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {

    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = "";

      try {
        this.isSubmitting = true;
        if(this.apiUrl != ""){
          console.log(this.apiUrl);
          await contactService.importFromApi(this.apiUrl);
        }else{
          if(this.file)
          await contactService.uploadContactsExcelFile(this.file);
          if(this.listImage) {
              await contactService.uploadListImageContact(this.listImage);
            }
        }
       
        this.__submitted();
        this.toastSuccessDelay(this.$t("importContactsFromFileSuccessful").toString());
        this.$bvModal.hide(this.modalId);

      } catch (e) {
        this.toastError(e);
      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
